<section>
  <div class="welcome">
    <!-- <div id="b-img"></div> -->
    <div class="welcome-text">
      <h1>Welcome</h1>
      <div class="text">
        <p>
          Thank you, your registration request has been recieved and is being
          processed
        </p>
        <p>Our team should complete the review process in less than <span>72 hours</span></p>
        <p>
          Please check your <span>email</span> for our message on the status of your account
        </p>
        <p><span>Thank you</span> once again for choosing Heirs General Insurance.</p>
      </div> 
      <a routerLink="/signin">
        <button mat-raised-button color="primary" style="font-weight: bold;"> Sign in to Proceed</button>
      </a>
      
    </div>
  </div>
</section>
